const absence = {
  'absence.title': 'Abwesenheiten',
  'absence.add': 'Abwesenheit eintragen',
  'absence.type.KRANK_MIT_ATTEST': 'KRmA – Krank mit Attest',
  'absence.type.KRANK_OHNE_ATTEST': 'KRoA – Krank ohne Attest',
  'absence.type.FZT': 'FZT – Freizeitausgleichstag',
  'absence.form.title': 'Neue Abwesenheit',
  'absence.form.employee': 'Mitarbeiter',
  'absence.form.choose': '– Bitte wählen –',
  'absence.form.type': 'Art der Abwesenheit',
  'absence.form.from': 'Von',
  'absence.form.to': 'Bis',
  'absence.form.notes': 'Bemerkung (optional)',
  'absence.form.save': 'Speichern',
  'absence.form.saving': 'Speichern…',
  'absence.form.cancel': 'Abbrechen',
  'absence.empty': 'Keine Abwesenheiten für {year}',
  'absence.col.employee': 'Mitarbeiter',
  'absence.col.type': 'Art',
  'absence.col.from': 'Von',
  'absence.col.to': 'Bis',
  'absence.col.workdays': 'Arbeitstage',
  'absence.col.notes': 'Bemerkung',
  'absence.col.createdBy': 'Eingetragen von',
  'absence.admin': 'Admin',
  'absence.delete': 'Löschen',
  'absence.confirm.delete': 'Abwesenheit wirklich löschen?',
  'absence.error.save': 'Fehler beim Speichern',
};

export default absence;
